// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addCalendar[data-v-d0fefbba] {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.wrapper[data-v-d0fefbba] {
  margin-top: 20px;
}
.wrapper[data-v-d0fefbba] label.custom-checkbox {
  margin-bottom: auto;
}
.people[data-v-d0fefbba] {
  flex-direction: row;
  margin-top: 8px;
  height: 48px;
}
.people .people-label[data-v-d0fefbba] {
  padding-left: 6px;
  line-height: 20px;
  display: flex;
  flex-direction: row;
  font-size: 0.8em;
  color: var(--placeholder-color);
}
.people .people-label .lbl-chosen-people[data-v-d0fefbba] {
  padding-left: 6px;
  height: 16px;
  font-size: 12px;
}
.people .people-choose[data-v-d0fefbba] {
  display: flex;
  width: 100%;
}
.people .people-choose input[data-v-d0fefbba] {
  color: var(--custom-textarea-color);
  transition-property: all;
  transition-duration: 1s;
  border: none;
  border-bottom: 1px solid var(--list-item-bordercolor);
  padding-left: 6px;
  width: 100%;
}
.people .people-choose input.disabled[data-v-d0fefbba] {
  color: var(--placeholder-color);
}
.people .people-choose input[data-v-d0fefbba]:focus {
  outline: none;
  border-bottom: 1px solid var(--ref-link-color);
}
.people .people-choose .ctipeople[data-v-d0fefbba] {
  height: 28px;
  margin-right: 14px;
  background-color: inherit;
  outline: none;
}
.people .people-choose .lblBtn[data-v-d0fefbba] {
  cursor: pointer;
  font-size: 26px;
}
.people .disabled[data-v-d0fefbba] {
  cursor: initial;
  color: var(--placeholder-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNewManagment/addToCalendar.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,qDAAqD;EACrD,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".addCalendar[data-v-d0fefbba] {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.wrapper[data-v-d0fefbba] {\n  margin-top: 20px;\n}\n.wrapper[data-v-d0fefbba] label.custom-checkbox {\n  margin-bottom: auto;\n}\n.people[data-v-d0fefbba] {\n  flex-direction: row;\n  margin-top: 8px;\n  height: 48px;\n}\n.people .people-label[data-v-d0fefbba] {\n  padding-left: 6px;\n  line-height: 20px;\n  display: flex;\n  flex-direction: row;\n  font-size: 0.8em;\n  color: var(--placeholder-color);\n}\n.people .people-label .lbl-chosen-people[data-v-d0fefbba] {\n  padding-left: 6px;\n  height: 16px;\n  font-size: 12px;\n}\n.people .people-choose[data-v-d0fefbba] {\n  display: flex;\n  width: 100%;\n}\n.people .people-choose input[data-v-d0fefbba] {\n  color: var(--custom-textarea-color);\n  transition-property: all;\n  transition-duration: 1s;\n  border: none;\n  border-bottom: 1px solid var(--list-item-bordercolor);\n  padding-left: 6px;\n  width: 100%;\n}\n.people .people-choose input.disabled[data-v-d0fefbba] {\n  color: var(--placeholder-color);\n}\n.people .people-choose input[data-v-d0fefbba]:focus {\n  outline: none;\n  border-bottom: 1px solid var(--ref-link-color);\n}\n.people .people-choose .ctipeople[data-v-d0fefbba] {\n  height: 28px;\n  margin-right: 14px;\n  background-color: inherit;\n  outline: none;\n}\n.people .people-choose .lblBtn[data-v-d0fefbba] {\n  cursor: pointer;\n  font-size: 26px;\n}\n.people .disabled[data-v-d0fefbba] {\n  cursor: initial;\n  color: var(--placeholder-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
